import request from '@/utils/request'

// 筛选条件列表
export function getSelectList() {
  return request({
    url: '/novel_management/novel_report_selects',
    method: 'get'
  })
}
// 获取公众号下拉筛选项 公众号组报表使用 公众号组绑定
export function getWechataccountlist() {
  return request({
    url: '/common/wechat_account_list',
    method: 'get'
  })
}
// 获取公众号下拉筛选项 公众号组报表使用 公众号组绑定新
export function platformaccountnew(params) {
  return request({
    url: '/platform/account/wechat_list_for_yonyou',
    method: 'get',
    params
  })
}

